import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { GLOBAL } from './global';
import { TokenService } from '../services/token.service';

@Injectable()
export class CybersecurityInstitucionalService {

  constructor(
    public http: HttpClient,
    private _tokenService:TokenService) {}

  urlAbout = `${GLOBAL.url}/cybersecurity/institucionalInformation`;
  headers = new HttpHeaders()

  saveInstitucionalInformation(inst:object){
    let params = JSON.stringify(inst);
    let token = this._tokenService.getToken();
    const HEADERS = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token
    })
    return this.http.post(this.urlAbout, params, { headers: HEADERS })
  }

  getInstitucionalInformation(){
    return this.http.get(this.urlAbout, {headers: this.headers})
  }

}
